// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ob-1";
export var messageSideRight = "_ob-2";
export var orderLookupBubbleContainer = "_ob-0";
export var submitButton = "_ob-3";